module.exports = __webpack_public_path__ + "static/assets/096b0f6faa117d82b8571d11750146aa.svg";